import {
  Container,
  Profile,
  Content,
  SubtitleContainer,
  CardGroup,
} from './styles';

import {
  FiInstagram,
  FiBriefcase,
  FiGithub,
  FiLinkedin,
  FiYoutube,
  FiBox,
} from 'react-icons/fi';
import { FaDiscord } from 'react-icons/fa';
import { VscRocket } from 'react-icons/vsc';

import CardLink from '../../components/CardLink';

import UserPhoto from '../../assets/profile.png';

const Home = () => {
  return (
    <Container>
      <Profile>
        <img src={UserPhoto} alt="Profile" />

        <h1>Fellipe Araujo</h1>
        <h2>Software Developer</h2>
      </Profile>

      <Content>
        <SubtitleContainer>
          <h2>Encontre-me</h2>
          <div className="line-division" />
        </SubtitleContainer>

        <CardGroup>
          <CardLink
            name="Portifólio"
            colorLeft="#0e1524"
            colorRight="#7bd6dc"
            link="https://fellipearaujo-portfolio.netlify.app"
            newLink
            stateTitle="Novo!"
          >
            <FiBriefcase size={25} color="#fff" />
          </CardLink>

          <CardLink
            name="Discord"
            colorLeft="#7289DA"
            colorRight="#a0b2f1"
            link="https://discords.com/bio/p/codemore"
          >
            <FaDiscord size={25} color="#fff" />
          </CardLink>
        </CardGroup>

        <CardGroup>
          <CardLink
            name="GitHub"
            colorLeft="#171717"
            colorRight="#5f6164"
            link="https://github.com/fellipe-araujo"
          >
            <FiGithub size={25} color="#fff" />
          </CardLink>

          <CardLink
            name="LinkedIn"
            colorLeft="#0D77B5"
            colorRight="#5cb2dd"
            link="https://www.linkedin.com/in/fellipearaujo"
          >
            <FiLinkedin size={25} color="#fff" />
          </CardLink>
        </CardGroup>

        <SubtitleContainer>
          <h2>Conteúdos Tech</h2>
          <div className="line-division" />
        </SubtitleContainer>

        <CardGroup>
          <CardLink
            name="Instagram"
            colorLeft="#9B59BF"
            colorRight="#D74C77"
            link="https://www.instagram.com/_codemore/"
          >
            <FiInstagram size={25} color="#fff" />
          </CardLink>

          <CardLink
            name="YouTube"
            colorLeft="#ED4631"
            colorRight="#F08A93"
            soon
            stateTitle="Em breve!"
          >
            <FiYoutube size={25} color="#fff" />
          </CardLink>
        </CardGroup>

        <CardGroup>
          <CardLink
            name="eBook FlexBox"
            colorLeft="#61dafb"
            colorRight="#9B79FC"
            soon
            stateTitle="Em breve!"
          >
            <FiBox size={25} color="#fff" />
          </CardLink>
          <CardLink
            name="eBook Deploy"
            colorLeft="#34af80"
            colorRight="#61fbc0"
            soon
            stateTitle="Em breve!"
          >
            <VscRocket size={25} color="#fff" />
          </CardLink>
        </CardGroup>
      </Content>
    </Container>
  );
};

export default Home;
